import axiosInstance, { handleLogout } from './axiosInstance';

export async function handleApiGetRequest(url, params) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axiosInstance.get(url, {params: params});
            resolve(result.data);
        } catch (error) {
            reject(error);
        }
    });
}

export async function handleApiPostRequest(url, data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axiosInstance.post(url, data);
            resolve(result.data);
        } catch (error) {
            reject(error);
        }
    });
}